/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const TvShowFilled: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="tv-show-filled" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M1133.3333333333333 1246.6666666666667C1195.6666666666667 1246.6666666666667 1246.6666666666665 1195.6666666666667 1246.6666666666665 1133.3333333333333V566.6666666666667C1246.6666666666665 504.3333333333334 1195.6666666666667 453.3333333333334 1133.3333333333333 453.3333333333334H736.6666666666666V340H963.3333333333331V226.6666666666668H396.6666666666667V340H623.3333333333333V453.3333333333334H113.3333333333333V1133.3333333333333C113.3333333333333 1195.6666666666667 164.3333333333333 1246.6666666666667 226.6666666666667 1246.6666666666667H1133.3333333333333zM396.6666666666667 1020V680H510V1020H396.6666666666667zM623.3333333333333 1020V680H736.6666666666666V1020H623.3333333333333zM850 1020V680H963.3333333333331V1020H850z" : "M906.6666666666669 997.3333333333334C956.5333333333334 997.3333333333334 997.3333333333334 956.5333333333334 997.3333333333334 906.6666666666666V453.3333333333333C997.3333333333334 403.4666666666667 956.5333333333334 362.6666666666667 906.6666666666669 362.6666666666667H589.3333333333334V272H770.6666666666667V181.3333333333333H317.3333333333334V272H498.6666666666667V362.6666666666667H90.6666666666667V906.6666666666666C90.6666666666667 956.5333333333334 131.4666666666667 997.3333333333334 181.3333333333334 997.3333333333334H906.6666666666669zM317.3333333333334 816V544H408V816H317.3333333333334zM498.6666666666667 816V544H589.3333333333334V816H498.6666666666667zM680 816V544H770.6666666666667V816H680z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
TvShowFilled.displayName = `Blueprint5.Icon.TvShowFilled`;
export default TvShowFilled;
